"use strict";

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _this = this;

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var Procedure_1 = require("./Procedure");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");

var utils_1 = require("../utils");

var entities_1 = require("../entities");
/**
 * @hidden
 */


exports.createRefreshSecurityTokenFactoryResolver = function (factories, securityTokenId) {
  return function () {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", factories.securityTokenFactory.refresh(securityTokenId));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
};
/**
 * Procedure to create a Checkpoint on a Security Token
 */


var CreateCheckpoint =
/*#__PURE__*/
function (_Procedure_1$Procedur) {
  _inherits(CreateCheckpoint, _Procedure_1$Procedur);

  function CreateCheckpoint() {
    var _this2;

    _classCallCheck(this, CreateCheckpoint);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(CreateCheckpoint).apply(this, arguments));
    _this2.type = types_1.ProcedureType.CreateCheckpoint;
    return _this2;
  }
  /**
   * Create a Checkpoint on the Security Token and return it
   */


  _createClass(CreateCheckpoint, [{
    key: "prepareTransactions",
    value: function prepareTransactions() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _this3 = this;

        var args, context, symbol, contractWrappers, factories, securityToken, securityTokenId, _ref, _ref2, checkpoint;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                args = this.args, context = this.context;
                symbol = args.symbol;
                contractWrappers = context.contractWrappers, factories = context.factories;
                _context3.prev = 3;
                _context3.next = 6;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 6:
                securityToken = _context3.sent;
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](3);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 12:
                securityTokenId = entities_1.SecurityToken.generateId({
                  symbol: symbol
                });
                _context3.next = 15;
                return this.addTransaction(securityToken.createCheckpoint, {
                  tag: types_1.PolyTransactionTag.CreateCheckpoint,
                  resolvers: [function (receipt) {
                    return __awaiter(_this3, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee2() {
                      var logs, _utils_1$findEvents, _utils_1$findEvents2, event, eventArgs, _checkpointId;

                      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              logs = receipt.logs;
                              _utils_1$findEvents = utils_1.findEvents({
                                logs: logs,
                                eventName: contract_wrappers_1.SecurityTokenEvents.CheckpointCreated
                              }), _utils_1$findEvents2 = _slicedToArray(_utils_1$findEvents, 1), event = _utils_1$findEvents2[0];

                              if (!event) {
                                _context2.next = 6;
                                break;
                              }

                              eventArgs = event.args;
                              _checkpointId = eventArgs._checkpointId;
                              return _context2.abrupt("return", factories.checkpointFactory.fetch(entities_1.Checkpoint.generateId({
                                securityTokenId: entities_1.SecurityToken.generateId({
                                  symbol: symbol
                                }),
                                index: _checkpointId.toNumber()
                              })));

                            case 6:
                              throw new PolymathError_1.PolymathError({
                                code: types_1.ErrorCode.UnexpectedEventLogs,
                                message: "The Checkpoint was successfully created but the corresponding event wasn't fired. Please report this issue to the Polymath team."
                              });

                            case 7:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2);
                    }));
                  }, exports.createRefreshSecurityTokenFactoryResolver(factories, securityTokenId)]
                })({});

              case 15:
                _ref = _context3.sent;
                _ref2 = _slicedToArray(_ref, 1);
                checkpoint = _ref2[0];
                return _context3.abrupt("return", checkpoint);

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 9]]);
      }));
    }
  }]);

  return CreateCheckpoint;
}(Procedure_1.Procedure);

exports.CreateCheckpoint = CreateCheckpoint;